export default "__VITE_ASSET__78bbdf85__$_?nuxt_component=async__"